import React, { useState, useEffect, useMemo } from 'react';

interface TypingHeroProps {
  className?: string;
}

const TypingHero: React.FC<TypingHeroProps> = ({ className = '' }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentStateIndex, setCurrentStateIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const states = useMemo(() => [
    { code: 'GA', name: 'Georgia' },
    { code: 'FL', name: 'Florida' },
    { code: 'CA', name: 'California' },
    { code: 'TX', name: 'Texas' },
    { code: 'NY', name: 'New York' },
    { code: 'IL', name: 'Illinois' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'OH', name: 'Ohio' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'MI', name: 'Michigan' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'VA', name: 'Virginia' }
  ], []);

  const baseText = "Ace Your ";
  const suffixText = " Real Estate Exam";

  useEffect(() => {
    const currentState = states[currentStateIndex];
    const targetText = baseText + currentState.code + suffixText;
    
    let timeout: NodeJS.Timeout;

    if (isWaiting) {
      // Wait before starting to delete
      timeout = setTimeout(() => {
        setIsWaiting(false);
        setIsDeleting(true);
      }, 2000); // Wait 2 seconds before deleting
    } else if (isDeleting) {
      // Delete characters
      if (displayText.length > baseText.length) {
        timeout = setTimeout(() => {
          setDisplayText(prev => prev.slice(0, -1));
        }, 30); // Super fast deletion
      } else {
        // Finished deleting, move to next state
        setIsDeleting(false);
        setCurrentStateIndex(prev => (prev + 1) % states.length);
      }
    } else {
      // Type characters
      if (displayText.length < targetText.length) {
        timeout = setTimeout(() => {
          setDisplayText(prev => targetText.slice(0, prev.length + 1));
        }, 50); // Super fast typing
      } else {
        // Finished typing, start waiting
        setIsWaiting(true);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayText, currentStateIndex, isDeleting, isWaiting, states]);

  return (
    <h1 className={`text-5xl lg:text-6xl font-bold mb-6 leading-tight ${className}`}>
      {displayText}
      <span className="animate-pulse">|</span>
    </h1>
  );
};

export default TypingHero;
